import { render, staticRenderFns } from "./A5Info.vue?vue&type=template&id=0303d311&"
import script from "./A5Info.vue?vue&type=script&lang=ts&"
export * from "./A5Info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports